module.exports = __webpack_public_path__ + "static/media/bt-download-normal.6701a5ab.svg";